export const awaitTimeout = (delay: number, reason: string) => {
    return new Promise((resolve, reject) => {
        return setTimeout(
            () => reject(reason),
            delay
        )
    });
}
